module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"product_option":"商品オプション","positive":"満足です","neutral":"普通です","negative":"物足りないです","expand_review":"もっと見る","collapse_review":"レビューを閉じる"}}')
  delete Component.options._Ctor
}
